<sc-master-detail [selection]="[selectedDefinition]" [data]="template.selectDefinitions"
  (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
  (deleteEntry)="onDeleteEntry($event);" [level]="2" class="template-lookup-editor no-field-space">

  @if (selectedDefinition) {
    <sc-flex vertical fitHeight stretchContent>
      <sc-padding>
        @if (selectedDefinition != null) {
          <ng-container [formGroup]="selectDefinitionFormGroup">
            <mat-form-field class="full-size-field" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-select-definition.identifier"></sc-dictionary-label>
              </mat-label>
              <input matInput name="identifier" formControlName="identifier"
                [required]="true" [maxLength]="255">
              </mat-form-field>
            </ng-container>
          }
        </sc-padding>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex-fitting-content vertical>
          <app-template-lookup-field-editor [selectDefinition]="selectedDefinition" [template]="template"></app-template-lookup-field-editor>
        </sc-flex-fitting-content>
      </sc-flex>
    }

  </sc-master-detail>
